<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="操作人">
              <j-dict-select-tag
                dictCode="`iwt-saas`.sys_user,realname,id"
                placeholder="请选择操作人"
                v-model="queryParam.userId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="加水点">
              <j-search-select-tag
                @change="searchQuery"
                dict="`iwt-wf`.dev_list,dev_name,id, del_flag=0 order by sort asc"
                placeholder="请选择加水点"
                ref="devSelect"
                v-model="queryParam.devId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="网关地址">
              <a-input placeholder="请输入网关地址" v-model="queryParam.hubcode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="是否发送">
              <j-multi-select-tag
                :options="ynOptions"
                @change="searchQuery"
                type="checkbox"
                v-model="queryParam.sendFlag"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="是否执行">
              <j-multi-select-tag
                :options="ynOptions"
                @change="searchQuery"
                type="checkbox"
                v-model="queryParam.exeFlag"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('设备下发消息')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical" />
          <a @click="rePublish(record)">重发</a>
        </span>
      </a-table>
    </div>

    <wf-dev-publish-msg-modal @ok="modalFormOk" ref="modalForm"></wf-dev-publish-msg-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfDevPublishMsgModal from './modules/WfDevPublishMsgModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { postAction } from '@/api/manage'

  export default {
    name: 'WfDevPublishMsgList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfDevPublishMsgModal
    },
    data () {
      return {
        description: '设备下发消息管理页面',
        // 表头
        columns: [
          {
            title: '设备',
            align: "center",
            sorter: true,
            dataIndex: 'devId_dictText'
          },
          {
            title: '操作人',
            align: "center",
            sorter: true,
            dataIndex: 'userId_dictText'
          },
          {
            title: '业务类型',
            align: "center",
            sorter: true,
            dataIndex: 'bizType'
          },
          {
            title: '消息主题',
            align: "center",
            sorter: true,
            dataIndex: 'msgTopic'
          },
          {
            title: '消息类型',
            align: "center",
            sorter: true,
            dataIndex: 'msgType'
          },
          {
            title: '网关地址',
            align: "center",
            sorter: true,
            dataIndex: 'hubcode'
          },
          {
            title: '是否发送',
            align: "center",
            sorter: true,
            dataIndex: 'sendFlag',
            customRender: (text) => (text == 1 ? '是' : '否'),
          },
          {
            title: '发送时间',
            align: "center",
            sorter: true,
            dataIndex: 'sendTime'
          },
          //   {
          //     title: '是否接收',
          //     align: "center",
          //     sorter: true,
          //     dataIndex: 'receiveFlag',
          //     customRender: (text) => (text == 1 ? '是' : '否'),
          //   },
          //   {
          //     title: '接收时间',
          //     align: "center",
          //     sorter: true,
          //     dataIndex: 'receiveTime'
          //   },
          {
            title: '是否执行',
            align: "center",
            sorter: true,
            dataIndex: 'exeFlag',
            customRender: (text) => (text == 1 ? '是' : '否'),
          },
          {
            title: '响应码',
            align: "center",
            dataIndex: 'resCode'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' },
          }
        ],
        isorter: {
          column: 'createTime',
          order: 'desc',
        },
        url: {
          list: "/wf/publishMsg/list",
          delete: "/wf/publishMsg/delete",
          deleteBatch: "/wf/publishMsg/deleteBatch",
          exportXlsUrl: "/wf/publishMsg/exportXls",
          importExcelUrl: "wf/publishMsg/importExcel",
          publish: "/wf/publishMsg/publish",
        },
        ynOptions: [
          { label: '否', value: '0' },
          { label: '是', value: '1' }
        ],
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.$set(this.dictOptions, 'sendFlag', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.$set(this.dictOptions, 'receiveFlag', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.$set(this.dictOptions, 'exeFlag', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      rePublish (record) {
        const that = this;
        postAction(this.url.publish, { id: record.id }).then((res) => {
          this.$message.success('重新发布成功')
          setTimeout(() => {
            that.searchQuery()
          }, 1000);
        })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'userId', text: '操作人', dictCode: '`iwt-saas`.sys_user,realname,id' })
        fieldList.push({ type: 'string', value: 'bizType', text: '业务类型', dictCode: '' })
        fieldList.push({ type: 'string', value: 'msgTopic', text: '消息主题', dictCode: '' })
        fieldList.push({ type: 'string', value: 'msgType', text: '消息类型', dictCode: '' })
        fieldList.push({ type: 'string', value: 'hubcode', text: '网关编号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'payload', text: '消息内容', dictCode: '' })
        fieldList.push({ type: 'switch', value: 'sendFlag', text: '是否发送' })
        fieldList.push({ type: 'date', value: 'sendTime', text: '发送时间' })
        fieldList.push({ type: 'switch', value: 'receiveFlag', text: '是否接收' })
        fieldList.push({ type: 'date', value: 'receiveTime', text: '接收时间' })
        fieldList.push({ type: 'switch', value: 'exeFlag', text: '是否执行' })
        fieldList.push({ type: 'date', value: 'exeTime', text: '执行时间' })
        fieldList.push({ type: 'string', value: 'resCode', text: '响应码', dictCode: '' })
        fieldList.push({ type: 'string', value: 'resInfo', text: '响应内容', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>